<header>
	<h3 *ngIf="mapping.label">
		{{ mapping.label }}
		<span *ngIf="mapping.month">({{ mapping.month | date: 'MM-YYYY' }})</span>

		<button
			mat-icon-button
			class="action-button"
			color="accent"
			*ngIf="canEditSummary && canEditMapping"
			(click)="onEditSummary()">
			<mat-icon aria-label="Edit">create</mat-icon>
		</button>
	</h3>

	<section class="creation-form" *ngIf="showSummaryForm">
		<app-structure-edit
			[structure]="mapping"
			(editFinished)="onEditSummaryFinished($event)"></app-structure-edit>
	</section>

	<button
		mat-raised-button
		color="accent"
		class="save"
		(click)="onSave()"
		[disabled]="!canSave || isSaving"
		*ngIf="canEditMapping">
		<mat-icon>save</mat-icon>
		{{ 'mapping.base.save.fullLabel' | translate }}
	</button>
	<button
		mat-raised-button
		color="accent"
		(click)="onExport(exportType.excel)"
		[disabled]="isDownloading"
		[matTooltip]="'mapping.base.excelExport.summary' | translate"
		*ngIf="!disableExport">
		<fa-icon icon="file-excel"></fa-icon>
		{{ 'mapping.base.excelExport.fullLabel' | translate }}
	</button>
	@if (canEditMapping && canImportMapping) {
        <button
            mat-raised-button
            color="accent"
            (click)="onExport(exportType.json)"
            [disabled]="isDownloading"
            [matTooltip]="'mapping.base.jsonExport.summary' | translate"
            *ngIf="!disableExport">
            <fa-icon icon="file-export"></fa-icon>
            {{ 'mapping.base.jsonExport.fullLabel' | translate }}
        </button>
        @if (!hasMapping) {
            <button
                mat-raised-button
                color="accent"
                (click)="toggleImport()"
                [disabled]="isDownloading"
                *ngIf="!disableExport">
                <fa-icon icon="file-import"></fa-icon>
                {{ 'mapping.base.jsonImport.fullLabel' | translate }}
            </button>
        }
	}
	@if (isImporting) {
		<app-upload-single
			[isLoading]="isUploading"
			(startUploading)="onImport($event)"></app-upload-single>
	}
	<mat-spinner diameter="25" *ngIf="isDownloading"></mat-spinner>
</header>

<div class="mapping-view" [ngClass]="{ 'show-list': doesShowList }">
	<section class="deps-list">
		<div class="actions">
			<button
				mat-icon-button
				color="accent"
				[matTooltip]="'mapping.base.closeList.summary' | translate"
				(click)="onToggleList()">
				<mat-icon>skip_previous</mat-icon>
			</button>
		</div>
		<app-dependencies-list
			class="dependencies-component"
			[canEditMapping]="canEditMapping"
			[dependencies]="mapping.notMapped"
			[label]="depsLabel"
			(listChanged)="onListChanged($event)"></app-dependencies-list>
	</section>

	<section class="tree">
		<div class="actions">
			<button
				mat-icon-button
				color="accent"
				*ngIf="!doesShowList"
				[matTooltip]="'mapping.base.openList.summary' | translate"
				(click)="onToggleList()">
				<mat-icon>skip_next</mat-icon>
			</button>
		</div>
		<app-tree
			[canEditMapping]="canEditMapping"
			[structure]="mapping.structure"
			[depsLabel]="depsLabel"
			[displayValidity]="displayValidity"></app-tree>
	</section>
</div>
